import PersonProfile from "@/components/PersonProfile";
import { PEOPLE, PERSON_LD } from "@/data/content";

const MarkDaviz = () => (
  <PersonProfile
    person={PEOPLE.mark}
    testPrefix="mark"
    seoTitle="Mark Daviz – Freier Trauredner, Redner & Sänger | Daviz & Puxi"
    seoDescription="Mark Daviz begleitet seit über sieben Jahren freie Trauungen, Willkommensfeiern und Jubiläen – und singt Ihr Lied live. Lernen Sie ihn persönlich kennen."
    seoPath="/mark-daviz"
    seoLd={PERSON_LD(window.location.origin, {
      name: "Mark Daviz",
      jobTitle: "Freier Trauredner & Sänger",
      image: PEOPLE.mark.image,
      path: "/mark-daviz",
    })}
  />
);

export default MarkDaviz;
